export default __webpack_public_path__ + "static/media/backgroundImage.fb05e519.png";